module.exports = __webpack_public_path__ + "media/images/game_icon/en/VG0003-0360bbb414f7e3ae9e10833af2040237.png";